export enum ModalSize {
    SMALL = '368px',
    MEDIUM = '500px',
    LARGE = '700px'
}
